<template>
  <div class="middle-pannel" v-if="pannelDatas.name != undefined">
    <div class="pannel-show">
      <div class="pannel-item">
        <div class="name">{{ dataArray[0].name }}</div>
        <div class="text">
          <div
            class="circle"
            :class="{ changeColor: pannelDatas.gatewayOnlineStatus == 0 }"
          ></div>
          {{ OnlineStatus[pannelDatas[dataArray[0].key]] || "-" }}
        </div>
      </div>
      <div class="pannel-item">
        <div class="name">{{ dataArray[1].name }}</div>
        <div class="text">
          <div
            class="circle"
            :class="{ changeColor: pannelDatas.powerSupplyStatus == null || 0 }"
          ></div>
          {{ SupplyStatus[pannelDatas[dataArray[1].key]] || "-" }}
        </div>
      </div>
    </div>
    <div class="line-middle1"></div>
    <div class="line-middle2"></div>
    <div class="box" style="padding: 20px 0">
      <div
        class="contentList"
        v-for="(value, key, index) in pannelDatas"
        :key="index"
      >
        <div class="text">{{ gateWayMap[key] || key }}</div>
        <div class="value">{{ value || "-" }}</div>
      </div>
    </div>
  </div>
  <!-- <div v-else class="middle-pannel">
    <div class="pannel-show">
      <div class="pannel-item">
        <div class="name">车位状态</div>
        <div class="text">
          <div
            class="circle"
            :class="{ changeColor: pannelDatas.gatewayOnlineStatus == 0 }"
          ></div>
          {{ "使用中" }}
        </div>
      </div>
      <div class="pannel-item">
        <div class="name">车位类型</div>
        <div class="text">
          {{ "充电车位" }}
        </div>
      </div>
    </div>
    <div class="line-middle1"></div>
    <div class="line-middle2"></div>
    <div class="between_infor">车辆信息</div>
    <div class="box">
      <div
        class="contentList"
        v-for="(value, key, index) in pannelDatas"
        :key="index"
      >
        <div class="text">{{ getCarData[key] || key }}</div>
        <div class="value">{{ value }}</div>
      </div>
    </div>
    <img style="width:208px;height:116px;margin-top:22px" src="" alt="">
  </div> -->
  <div v-else class="middle-pannel">
    <div class="box">
      <div
        class="contentList"
        v-for="(value, key, index) in pannelDatas"
        :key="index"
      >
        <div class="text">{{ getCarData[key] }}</div>
        <div class="value carData" :class="{ errorColor: value.alarm == '1' }">
          {{ (value.value == "暂无数据" ? "--" : value.value) || value }}
        </div>
      </div>
    </div>
    <div class="car_park">
      <div class="imgIcon" @click="amplifier"></div>
      <img :src="carUrl.value" @pointerdown="amplifier" />
      <div class="line"></div>
    </div>
    <div class="amplifier" v-if="flag">
      <!-- 框 -->
      <div class="win">
        <!-- 四个角的边框效果 -->
        <div class="border_corner border_corner_left_top"></div>
        <div class="border_corner border_corner_right_top"></div>
        <div class="border_corner border_corner_left_bottom"></div>
        <div class="border_corner border_corner_right_bottom"></div>
        <div class="main">
          <img :src="carUrl.value" />
          <div class="close" @click="flag = false"></div>
          <!-- 这里写内容 -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    pannelDatas: Object,
    carUrl: Object,
  },
  data() {
    return {
      itemIndex: 0,
      OnlineStatus: ["离线", "在线"],
      SupplyStatus: ["断电", "正常"],
      gateWayMap: {
        name: "网关名称",
        hardwareId: "mac地址",
        version: "固件版本",
        networkingType: "连网方式",
        ipAddress: "IP地址",
        positionCode: "网关编码",
        position: "安装位置",
        usage: "网关用途",
        lastHeartbeat: "最近心跳包时间",
        gatewayOnlineStatus: "在线状态",
        powerSupplyStatus: "供电状态",
        remark: "备注",
        offlineTime: "离线时间",
      },
      getCarData: {
        LicensePlate: "车牌号",
        number: "停放车位",
        comeTime: "进场时间",
      },
      dataArray: [
        {
          name: "在线状态",
          key: "gatewayOnlineStatus",
        },
        {
          name: "供电状态",
          key: "powerSupplyStatus",
        },
      ],
      flag: false,
    };
  },
  methods: {
    setVal(val) {
      console.log(val, "val");
      if (val == "0") {
        val = "0";
      }
      return val;
    },
    sendDate(index) {
      this.itemIndex = index;
    },
    amplifier() {
      this.flag = !this.flag;
    },
  },
};
</script>

<style lang="scss" scoped>
.disabled-btn {
  // pointer-events: none;
}

.middle-pannel {
  padding: 0 20px;
  margin-top: 10px;

  .line-middle1 {
    // margin: 0 20px;
    width: 341px;
    height: 1px;
    background: rgba(217, 217, 217, 0.1);
  }
  .line-middle2 {
    // margin: 0 20px;
    width: 341px;
    height: 1px;
    background: rgba(0, 0, 0, 0.2);
  }
  .between_infor {
    // width: 56px;
    // height: 21px;
    margin: 20px 0;
    font-size: 14px;
    font-weight: 700;
    font-family: "Source Han Sans CN";
  }

  .pannel-show {
    display: grid;
    grid-template-columns: 165px 165px;
    gap: 10px;
    margin-bottom: 10px;
  }

  .pannel-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 4px 8px;
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 4px;

    .name {
      width: 56px;
      height: 21px;
      font-size: 14px;
      line-height: 21px;
      color: rgba(239, 239, 239, 0.7);
    }

    .text {
      height: 18px;
      font-weight: 500;
      font-size: 12px;
      line-height: 18px;
      color: #fff;
      display: flex;
      align-items: baseline;
      .circle {
        width: 8px;
        height: 8px;
        background-color: #72ff91;
        border-radius: 50%;
        margin-right: 8px;
      }
      .changeColor {
        background-color: #a2a3a5;
      }
    }
  }

  /**/
  .box {
    .contentList {
      padding: 4px 10px;
      display: flex;
      align-items: center;
      font-size: 14px;
      color: rgba(239, 239, 239, 0.7);
      background: linear-gradient(
        270deg,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 0.2) 100%
      );
      .text {
        width: 80px;
        margin-right: 20px;
      }
      .value {
        color: #fff;
        width: 220px;
      }
      .carData {
        font-size: 20px;
      }
      .errorColor {
        color: #f1802f;
      }
    }
  }

  .equ {
    .equList {
      display: flex;
      width: 341px;
      height: 25px;
      padding: 2px 10px;
      margin-bottom: 4px;
      font-size: 14px;
      color: rgba(239, 239, 239, 0.7);

      .text {
        width: 80px;
        margin-right: 20px;
      }
    }

    .bg {
      background: linear-gradient(
        270deg,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 0.2) 100%
      );
    }
  }

  .repair {
    ::v-deep .el-timeline-item__node--normal {
      width: 6px;
      height: 6px;
      left: 2px;
    }

    ::v-deep .el-timeline-item__content {
      color: #fff;
    }

    ::v-deep .el-timeline-item__timestamp {
      margin-top: 2px;
      padding-left: 10px;
      width: 284px;
      height: 22px;
      line-height: 22px;
      background: linear-gradient(
        270deg,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 0.2) 100%
      );
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    ::v-deep .el-timeline-item {
      padding-bottom: 10px;
    }
  }

  /**/

  .name-detail {
    color: rgba(239, 239, 239, 0.7) !important;
    padding-left: 10px;
  }

  .pannel-off {
    background: linear-gradient(
      270deg,
      rgba(0, 137, 255, 0) -1.46%,
      rgba(23, 110, 237, 0.25) 108.48%
    );
    // border: 1px solid ;
  }

  .pannel-btn {
    background-image: url("../../../assets/cut/show.png");
    background-size: cover;
    width: 356px;
    height: 12px;
    cursor: pointer;
  }

  .pannel-btns {
    background-image: url("../../../assets/cut/shows.png") !important;
  }

  .car_park {
    position: relative;
    width: 342px;
    height: 191px;
    margin-top: 13px;
    .imgIcon {
      position: absolute;
      width: 29px;
      height: 20px;
      bottom: 11px;
      right: 11px;
      background-image: url("../../../assets/compImg/parking/imgIcon.png");
      background-size: cover;
    }
    &::before {
      content: "";
      position: absolute;
      top: -1px;
      left: -1px;
      width: 6px;
      height: 6px;
      border-top: 1px solid #fff;
      border-left: 1px solid #fff;
    }

    &::after {
      content: "";
      position: absolute;
      top: -1px;
      right: 0px;
      width: 6px;
      height: 6px;
      border-right: 1px solid #fff;
      border-top: 1px solid #fff;
    }
    .line::before {
      content: "";
      position: absolute;
      bottom: 0px;
      left: 0px;
      width: 6px;
      height: 6px;
      border-bottom: 1px solid #fff;
      border-left: 1px solid #fff;
    }

    .line::after {
      content: "";
      position: absolute;
      bottom: 0px;
      right: 0px;
      width: 6px;
      height: 6px;
      border-bottom: 1px solid #fff;
      border-right: 1px solid #fff;
    }
    img {
      width: 342px;
      height: 191px;
    }
  }
}
.amplifier {
  position: absolute;
  top: 176px;
  left: -843px;
  width: 764px;
  height: 430px;
  background: rgba(255, 255, 255, 0.35);
  border: 1px solid #2e82ff;
  backdrop-filter: blur(13.5px);

  .win {
    margin: -9px;
    position: relative;
    display: inline-block;
  }
  .main {
    width: 782px;
    height: 449px;
    border: none;
    img {
      margin: 16px 18px;
      width: 746px;
      height: 417px;
    }
    .close {
      position: absolute;
      top: 19px;
      right: 19px;
      width: 48px;
      height: 36px;
      background-image: url("../../../assets/cut/close-img.png");
      background-size: 100%;
      cursor: pointer;
    }
  }
  .border_corner {
    z-index: 2500;
    position: absolute;
    width: 14px;
    height: 14px;
    border: 2px solid #2e82ff;
  }
  .border_corner_left_top {
    top: 0;
    left: 0;
    border-right: none;
    border-bottom: none;
  }
  .border_corner_right_top {
    top: 0;
    right: 0;
    border-left: none;
    border-bottom: none;
  }
  .border_corner_left_bottom {
    bottom: 0;
    left: 0;
    border-right: none;
    border-top: none;
  }
  .border_corner_right_bottom {
    bottom: 0;
    right: 0;
    border-left: none;
    border-top: none;
  }
}
</style>
